/*eslint-disable */
import ViewBulkJob from "./ViewBulkJob";

export default ViewBulkJob;
